import { PLACEHOLDERS } from "assets/images";
import clsx from "clsx"; // optional, for cleaner class merging

const ThumbnailImage = ({
  primaryImage,
  images,
  className,
  alt = "thumbnail",
  size = "sm",
  ...props // allows passing other img props
}) => {
  // Ensure images is always an array
  const imageArray = Array.isArray(images) ? images : [];

  // Pick primary image > first image > placeholder
  const renderThumb = primaryImage || imageArray[0] || PLACEHOLDERS.comingSoon;

  // Merge default class with custom class
  const combinedClassName = clsx(`rounded avatar-${size}`, className);

  return <img className={combinedClassName} src={renderThumb} alt={alt} {...props} />;
};

export default ThumbnailImage;
